import { gql } from "@apollo/client";

export const UNSUBSCRIBE_FROM_REPORTS = gql`
  mutation updateSubscriptions($unsubscribeToken: String!, $reportIDs: [Int]) {
    unsubscribeFromReports(unsubscribeToken: $unsubscribeToken, reportIDs: $reportIDs)
  }
`;
